import { Suspense, useState } from 'react';
import ErrorBoundary from '@/app/components/feedback/ErrorBoundary';
import { lazyWithRetry } from '@/app/helpers/lazyWithRetry';
import { useAiModuleEnabled } from '../core/_hooks';
import { isChatwootConfigured } from '../core/provider';
import AgentChatLauncher from './AgentChatLauncher';
import './AgentChatMessenger.scss';

const UnifiedChatContainer = lazyWithRetry('UnifiedChatContainer', () => import('./UnifiedChatContainer'));

const AgentChatWidget = () => {
  const aiEnabled = useAiModuleEnabled();
  const chatwoot = isChatwootConfigured();
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  if (!chatwoot && !aiEnabled) return null;

  const openPanel = () => {
    setHasOpened(true);
    setIsOpen(true);
  };

  const togglePanel = () => {
    if (isOpen) setIsOpen(false);
    else openPanel();
  };

  return (
    <>
      {hasOpened ? (
        <div
          className={`agent-chat-widget__panel position-fixed ${isOpen ? 'agent-chat-widget__panel--open' : ''}`}
          data-testid="agent-chat-panel"
        >
          <ErrorBoundary>
            <Suspense fallback={null}>
              <UnifiedChatContainer onClose={() => setIsOpen(false)} />
            </Suspense>
          </ErrorBoundary>
        </div>
      ) : null}
      <AgentChatLauncher isOpen={isOpen} onToggle={togglePanel} />
    </>
  );
};

export default AgentChatWidget;
